import createIcon from '../../createIcon';

/**
 * @component @name Map
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNSAzTDIwLjM0IDMuMDNMMTUgNS4xTDkgM0wzLjM2IDQuOUMzLjE1IDQuOTcgMyA1LjE1IDMgNS4zOFYyMC41QzMgMjAuNzggMy4yMiAyMSAzLjUgMjFMMy42NiAyMC45N0w5IDE4LjlMMTUgMjFMMjAuNjQgMTkuMUMyMC44NSAxOS4wMyAyMSAxOC44NSAyMSAxOC42MlYzLjVDMjEgMy4yMiAyMC43OCAzIDIwLjUgM1pNMTUgMTlMOSAxNi44OVY1TDE1IDcuMTFWMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Map = createIcon('Map', [
  [
    'path',
    {
      d: 'M20.5 3L20.34 3.03L15 5.1L9 3L3.36 4.9C3.15 4.97 3 5.15 3 5.38V20.5C3 20.78 3.22 21 3.5 21L3.66 20.97L9 18.9L15 21L20.64 19.1C20.85 19.03 21 18.85 21 18.62V3.5C21 3.22 20.78 3 20.5 3ZM15 19L9 16.89V5L15 7.11V19Z',
      key: '3r6mww',
    },
  ],
]);

export default Map;
